<template>
  <div>
    <b-card>
      <b-alert :show="errors.length > 0" variant="danger">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form>
        <div>
          <b-row>
            <div class="col-md-6">
              <b-form-group id="input-group-1" label="عنوان تیکت *: " label-for="input-1">
                <b-form-input id="input-1" required v-model="Ticket.subject" placeholder="عنوان تیکت "></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group id="input-group-2" label="اهمیت: " label-for="input-2">
                <b-form-select id="input-2" v-model="Ticket.mdid2_periority" :options="priorities"></b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group id="input-group-3" label="دپارتمان: " label-for="input-3">
                <b-form-select id="input-3" v-model="Ticket.department_id" :options="departments"></b-form-select>
              </b-form-group>
            </div>
          </b-row>
          <b-form-group id="input-group-4" label="متن تیکت: " label-for="input-4">
            <b-form-textarea id="input-4" v-model="Ticket.text" placeholder="متن تیکت را اینجا تایپ کنید"
              rows="8"></b-form-textarea>
          </b-form-group>
        </div>
        <div class="row">
          <div class="col-md-3 mt-3" v-for="(x, index) in Ticket.files" v-bind:key="x.file_id">
            <!-- <b-img :src="x.fileUrl" fluid></b-img> -->
            <b-button class="mr-5" @click="delete_attachment(index)" size="sm">
              <b-icon icon="trash"></b-icon>
            </b-button>
            <a target="_blank" href="#" @click.prevent="httpHelper.getFileUrl(x.file_id)">پیوست شماره {{ index + 1 }}</a>
          </div>
        </div>
        <div class="mt-3">
          <div class="col-ms-4">
            <div>
              <b-form-group id="input-group-4" label="اضافه کردن پیوست: " label-for="input-4">
                <fileUploader v-model="file" v-bind:fileUploaded="fileUploaded"></fileUploader>
              </b-form-group>
            </div>
          </div>
        </div>
        <b-row class="mt-3">
          <b-col>
            <b-button class="mr-3" variant="danger" @click="$router.push('tickets')">بازگشت</b-button>
            <b-button class="mr-3" variant="success" @click="submitTicket" :class="'ml-3 ' + (isBusyAddTicket ? 'spinner spinner-light spinner-right' : '')
              ">ثبت تیکت</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import fileUploader from "../../components/fileUploader";
import routesMap from '@/helpers/routesMap'
export default {
  name: "addTicket",
  components: {
    fileUploader,
  },
  data: function () {
    return {
      isBusyAddTicket: false,
      errors: [],
      priorities: [],
      departments: [],
      ticket_subject: null,
      ticket_content: null,
      ticket_department: null,
      ticket_priority: 6,
      file: "",
      Ticket: {
        subject: "",
        department_id: 2,
        mdid2_periority: 6,
        text: "",
        mdid1_status: 1,
        files: [],
      },
      routesMap,
      httpHelper,
    };
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "تیکت ها", route: "/tickets" },
      { title: "ثبت تیکت" },
    ]);
    httpHelper.setAuth();
    httpHelper
      .getData("/metadata?metadata_group_id=2")
      .then((response) => {
        this.priorities = response.result.map((item) => {
          return { value: item.id, text: item.title };
        });
      })
      .catch((error) => { })
      .finally(() => { });

    httpHelper
      .getData("/departments")
      .then((response) => {
        this.departments = response.result
          .filter((item) => {
            return item.department_status.id == 1717;
          })
          .map((item) => {
            return { value: item.id, text: item.name };
          });
      })
      .catch((error) => { })
      .finally(() => { });
  },
  methods: {
    fileUploaded: function () {
      this.Ticket.files.push({ file_id: this.file });
      this.file = "";
    },
    submitTicket: function () {
      this.isBusyAddTicket = true;
      httpHelper
        .postData("tickets", this.Ticket)
        .then((response) => {
          this.isBusyAddTicket = false;
          if (response.success) {
            this.$router.push({ path: "/ticketDetails/" + response.result, query: { ticket: 'new' } });
          } else {
            for (const key in response.error) {
              if (response.error.hasOwnProperty(key)) {
                const element = response.error[key];
                element.forEach((er) => {
                  this.errors.push(er);
                });
              }
            }
          }
        })
        .catch((error) => { })
        .finally(() => { });
    },
    delete_attachment(index) {
      this.Ticket.files.splice(index, 1);
    },
    async openFile(fileId, index) {
      const file = this.Ticket.files[index];
      if (file.fileUrl) {
        window.open(file.fileUrl, '_blank');
        return;
      }
      try {
        const imageUrl = await httpHelper.getImage(fileId);
        const url = imageUrl.result.url || '';
        if (url) {
          this.$set(this.Ticket.files[index], 'fileUrl', url);
          window.open(url, '_blank');
        } else {
          alert('لینک فایل در دسترس نیست.');
        }
      } catch (err) {
        console.error(err);
        alert('خطا در دریافت لینک فایل');
      }
    },
  },
  mounted() { },
};
</script>